import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { Location } from '@angular/common';
import { AccountDataSourceService } from 'src/app/services/account-data-source.service';

@Component({
  selector: 'app-view-account',
  templateUrl: './view-account.component.html',
  styleUrls: ['./view-account.component.css']
})
export class ViewAccountComponent implements OnInit {
  routeLinks: any[];
  activeLinkIndex = -1;
  accountDetails: any = '';
  id: any;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private accountService: AccountService, private accountData: AccountDataSourceService,
    private _location: Location) {

    this.activatedRoute.params.subscribe(params => {
      this.accountService.next(params);

    }
    );

    this.routeLinks = [
      {
        label: 'ACCOUNT DETAILS',
        link: './details',
        index: 0
      }, {
        label: 'LICENSE DETAILS',
        link: './licensedetails',
        index: 1
      }, {
        label: 'JALDEE SUBSCRIPTION',
        label1: 'PAYMENT STATEMENTS',
        link: './invoice',
        index: 2
      },
      {
        label: 'PAYMENT SETTINGS',
        link: './paymentdetails',
        index: 3
      }, {
        label: 'TEST TRANSACTIONS',
        link: './transactions',
        index: 4
      }
      , {
        label: 'LICENSE PAYMENT ',
        label1: 'HISTORY',
        link: './history',
        index: 5
      }, {
        label: 'QUESTIONNAIRE',
        link: './question',
        index: 6
      }, {
        label: 'SECTION',
        link: './section',
        index: 7
      }, {
        label: 'APP REGISTRATION',
        link: './apps',
        index: 8
      }
      , {
        label: 'DATA MIGRATION',
        link: './migration',
        index: 8
      }
      , {
        label: 'CONSENT FORM',
        link: './consentForm',
        index: 8
      }
      // , {
      //   label: 'PWA',
      //   link: './pwa',
      //   index: 7
      // },
      // {
      //   label: 'Custom Templates',
      //   link: './templates',
      //   index: 8
      // }
    ];
  }

  ngOnInit() {
    this.activatedRoute.data.subscribe((res) => console.log('view from component' + JSON.stringify(res)));

    this.router.events.subscribe((res) => {
      this.activeLinkIndex = this.routeLinks.indexOf(this.routeLinks.find(tab => tab.link === '.' + this.router.url));
    });
  }
  // goBacktoList() {
  //     this.router.navigate(['../../filter/list'], { relativeTo: this.activatedRoute };)
  // }

  goBacktoList() {
    this.accountData.setAccountToolBarVal(false);
    this._location.back();
  }
}
